import { render } from "./dynamic_landing_page.html?vue&type=template&id=226c7b49&scoped=true&external"
import script from "./dynamic_landing_page.js?vue&type=script&lang=js&external"
export * from "./dynamic_landing_page.js?vue&type=script&lang=js&external"

import "./DynamicLandingPage.vue?vue&type=style&index=0&id=226c7b49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226c7b49"]])

export default __exports__